const binding = { modules: {}, dataActions: {} };

    (binding.modules['master'] = {
        c: () => require('partner/themes/master/master.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['account-profile','active-image','b2b-requests-status','business-organization-list','buybox','carousel','cart-icon','cart','checkout-billing-address','checkout-order-confirmation','checkout-shipping-address','checkout','content-block','header','image-list','navigation-menu','order-confirmation','order-details','order-history','order-template-list','order-template','product-collection','product-comparison','product-specification','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','sign-in','site-picker','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'master',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'master.theme.settings.json',
        md: 'src/themes/master'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };